import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SKIP_TENANT_HEADER } from './skip-tenant-header.token';

/** Add Active-Tenant-Identifier header to request. */
@Injectable()
export class AddTenantHeaderInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let request = req;

    if (req.context.get(SKIP_TENANT_HEADER)) {
      return next.handle(request);
    }

    const isTenantsListRequest = /tenants\/?(\?.*)?$/.test(req.url);
    if (req.url.includes('tce-experience-admin') && !isTenantsListRequest) {
      // Can't use brandService.currentBrand because it will not be set initially on page refresh
      const brandId = sessionStorage.getItem('brand_id');
      const header = req.headers.get('Active-Tenant-Identifier');
      if (brandId && !header) {
        request = this.setTenantHeader(req, brandId);
      }
    }
    return next.handle(request);
  }

  /**
   * Sets 'Active-Tenant-Identifier' header with given brandId
   *
   * @param req request to set
   * @param brandId to set
   */
  private setTenantHeader(req: HttpRequest<any>, brandId: string): HttpRequest<any> {
    const request = req.clone({
      headers: req.headers.set('Active-Tenant-Identifier', brandId),
    });
    return request;
  }
}
